import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-introtext',
  templateUrl: './introtext.component.html',
  styleUrls: ['./introtext.component.scss']
})
export class IntrotextComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/introtext/introtext.component.ts